export default {
  ogTitle: {
    id: 'comparison_page_og_title',
    defaultMessage: '{firstProduct} vs {secondProduct} comparison',
  },
  ogDescription: {
    id: 'comparison_page_og_description',
    defaultMessage:
      '{firstProduct} vs {secondProduct} comparison: which one is the best for you?',
  },
  ogSection: {
    id: 'comparison_page_og_section',
    defaultMessage: 'Comparison',
  },
} as const
